import { useMutation } from 'react-query'
import { endpoints } from '@app/api/config'
import { apiAuthClient } from '@app/services/apiAuthClient'
import {
  ApiBillingInfo,
  ApiBillingResponse,
  ApiErrorResponse,
} from 'BackendApi'
import { AxiosResponse } from 'axios'

type PatchBillingParams = {
  requestBody: ApiBillingInfo
}

const patchBillingInfo = async ({
  requestBody,
}: PatchBillingParams): Promise<ApiBillingResponse> => {
  const apiResponse: AxiosResponse<ApiBillingResponse> =
    await apiAuthClient.patch(endpoints.billingInfo, requestBody)
  return apiResponse.data
}

export const useUpdateBillingInfo = () =>
  useMutation<ApiBillingResponse, ApiErrorResponse, PatchBillingParams>(
    patchBillingInfo
  )
